import Request from "./request";

export default class InvoiceService {
	static instance() {
		if (this._instance) {
			return this._instance;
		}
		return this._instance = new InvoiceService();
	}

	getInvoices(search = { page: 0, size: 10 }) {
		return Request.instance().post("/console/v1/invoice/list", search);
	}

	getInvoiceById(id) {
		return Request.instance().get("/console/v1/invoice/" + id);
	}

	payInvoice(invoiceId) {
		return Request.instance().put(`/console/v1/invoice/${invoiceId}/pay`);
	}
}